import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateClient($companyId: ID!, $id: ID!, $attributes: ClientAttributes!) {
    updateClient(companyId: $companyId, id: $id, attributes: $attributes) {
      client {
        id
        ...UpdatedClient
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedClient on Client {
    id
    organisationName
    clientType { id name }
    phone
    email
    address1
    address2
    address3
    city
    county
    postcode
  }
`
